module.exports = __webpack_public_path__ + "static/img/10.f62f94a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/10.png
// module id = /XLB
// module chunks = 0